import { dispatchPointerEvent } from '../utils/events.es.js';
var press = {
  isActive: function isActive(options) {
    return Boolean(options.press);
  },
  subscribe: function subscribe(element, _ref) {
    var enable = _ref.enable,
      disable = _ref.disable;
    var onPointerUp = function onPointerUp(event) {
      disable();
      dispatchPointerEvent(element, "pressend", event);
      window.removeEventListener("pointerup", onPointerUp);
    };
    var onPointerDown = function onPointerDown(event) {
      enable();
      dispatchPointerEvent(element, "pressstart", event);
      window.addEventListener("pointerup", onPointerUp);
    };
    element.addEventListener("pointerdown", onPointerDown);
    return function () {
      element.removeEventListener("pointerdown", onPointerDown);
      window.removeEventListener("pointerup", onPointerUp);
    };
  }
};
export { press };